 
 
 
 
 
 
define([
    'model/objectModel',
    'services/reverseGeocode/reverseGeocode',
    '../../services/utils'
], function(
    ObjectModel,
    reverseGeocode,
    utils
) {
    'use strict';

    var EntryPointModel = function(json, parent) {
        this.position = utils.convertToLatLng(json.position);
        this.type = json.type;
        this.parent = parent;

        return this;
    };

    EntryPointModel.prototype = Object.create(ObjectModel.prototype);
    EntryPointModel.prototype.constructor = EntryPointModel;

    EntryPointModel.prototype.simplify = function() {
        return {
            position: {lat: this.position.lat, lon: this.position.lng},
            type: this.type
        };
    };

    EntryPointModel.prototype.getAddress = function() {
        return reverseGeocode().position({lat: this.position.lat, lon: this.position.lng}).go();
    };
    return EntryPointModel;
});



// WEBPACK FOOTER //
// ./model/search/entryPointModel.js